import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetParentCategoriesQuery, useGetCategorybyIdQuery } from "../../Services/CategoryAPI";
import { useParams } from "react-router-dom";


function AddCategory() {
    const { id } = useParams();
    console.log("id", id)
    const [categoryType, setCategoryType] = useState("main category");
    const [categoryName, setCategoryName] = useState("");
    const [categoryImage, setCategoryImage] = useState(null);
    const [parentCategory, setParentCategory] = useState(0);
    const [description, setDescription] = useState("");
    const [isFeatured, setisFeatured] = useState(0);


    const { data: parentCategories } = useGetParentCategoriesQuery();
    const { data: categoryDetail, isLoading: loadingContent, error, refetch: refetchCategoryDetail } = useGetCategorybyIdQuery(id);



    useEffect(() => {
        refetchCategoryDetail();
    })

    useEffect(() => {
        console.log("categoryDetail?.data?.parent_id", categoryDetail?.data?.parent_id);
        setCategoryName(categoryDetail?.data?.category_name);
        setDescription(categoryDetail?.data?.description);
        setisFeatured(categoryDetail?.data?.is_featured);
        if (categoryDetail?.data?.parent_id === 0) {
            setCategoryType("main category");
        }
        else {
            setCategoryType("sub category");
            setParentCategory(categoryDetail?.data?.parent_id)
        }
    }, [categoryDetail])

    useEffect(() => {
        console.log("categoryImage", categoryImage);
    }, [categoryImage])



    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>View Category</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/list-category"><span>Category</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>
            <div className="text-end">
                <Link to={`/edit-category/${id}`}><button className="btn-primary mb-4"><FontAwesomeIcon
                    icon={faEdit}
                    className="text-primary mx-2"
                />Edit</button></Link>
            </div>
            <div className="content-wrapper">
                <form >
                    <div className="row">
                        {/* Category Name */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_name" className="form-label">Category Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="category_name"
                                    placeholder="Enter Category Name"
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                />
                               
                            </div>
                        </div>


                        {/* Category Type */}
                        <div className="col-md-6 col-sm-12 col-lg-6">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_type" className="form-label">Category Type</label>
                                <select
                                    id="category_type"
                                    className="form-control"
                                    value={categoryType}
                                    onChange={(e) => setCategoryType(e.target.value)}
                                >
                                    <option value="main category">Main Category</option>
                                    <option value="sub category">Sub Category</option>
                                </select>
                            </div>
                        </div>

                        {/* Parent Category (Only if Sub Category is selected) */}
                        {categoryType === "sub category" && (
                            <div className="col-md-6 col-sm-12 col-lg-6">
                                <div className="mb-4 text-start">
                                    <label htmlFor="parent_id" className="form-label">Select Parent Category</label>
                                    <select
                                        id="parent_id"
                                        className="form-control"
                                        value={parentCategory}
                                        onChange={(e) => setParentCategory(e.target.value)}
                                    >
                                        <option value="">Select Parent Category</option>
                                        {parentCategories?.data?.map((category) => (
                                            <option value={category.id}>{category.category_name}</option>
                                        ))}

                                    </select>
                                    
                                </div>
                            </div>
                        )}

                        {/* Description */}
                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start">
                                <label htmlFor="description" className="form-label w-100">Description</label><br />
                                <textarea
                                    rows={4}
                                    name="description"
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                
                            </div>
                        </div>

                        <div className="col-md-12 col-sm-12 col-lg-12">
                            <div className="mb-4 text-start d-flex">

                                <input
                                    type="checkbox"
                                    checked={isFeatured === 1}
                                    name="isFeatured"
                                    onChange={(e) => setisFeatured(e.target.checked ? 1 : 0)}
                                /><label htmlFor="description" className="form-label w-100">Is Featured</label>
                            </div>
                        </div>

                        {/* Category Image */}
                        <div className="col-md-6 col-sm-12 col-lg-6 d-block">
                            <div className="mb-4 text-start">
                                <label htmlFor="category_image" className="form-label">Category Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="category_image"
                                    onChange={(e) => setCategoryImage(e.target.files[0])}
                                />
                            </div>
                            <img src={categoryDetail?.data?.category_image_url} className="category-edit-img" alt="category-img"/>
                        </div>

                    </div>

                </form>
            </div>
        </div>
    );
}

export default AddCategory;
